import styled from 'styled-components';
import { Spin as spin } from 'antd';

const Spin = styled(spin)``;

/** @component */
export default Spin;
